import {
    SHOW_SAVED_MESSAGE,
    UPDATE_BI_ACCOUNT,
    SET_ACCOUNT_HISTORY_SLICE,
    SET_ACTIVITY_POINTS,
    SET_ERROR_LOADING_ACTIVITY_POINTS,
    SET_CUSTOMER_LIMIT,
    SET_CUSTOMER_LIMIT_ERROR
} from 'constants/actionTypes/profile';

const initialState = {
    biAccount: null,
    accountHistorySlice: null,
    activityPoints: {
        records: null,
        error: false
    },
    showSavedMessage: false,
    customerLimit: {
        currency: null,
        balance: {
            initial: null,
            initialExpiryDate: null,
            totalSpend: null,
            available: null
        },
        error: null
    }
};

const reducer = function (state = initialState, action) {
    const payload = action.payload;

    switch (action.type) {
        // Profile-related actions
        case UPDATE_BI_ACCOUNT:
            return {
                ...state,
                biAccount: action.biAccount
            };

        case SET_ACCOUNT_HISTORY_SLICE:
            return {
                ...state,
                accountHistorySlice: action.accountHistorySlice
            };
        case SET_ACTIVITY_POINTS:
            return {
                ...state,
                activityPoints: {
                    ...action.activityPoints,
                    // Append records if page > 1, otherwise replace
                    records:
                        action.activityPoints.pageNumber > 1
                            ? [...(state.activityPoints.records || []), ...(action.activityPoints.records || [])]
                            : action.activityPoints.records
                }
            };
        case SET_ERROR_LOADING_ACTIVITY_POINTS:
            return {
                ...state,
                activityPoints: {
                    ...state.activityPoints,
                    error: true
                }
            };
        case SHOW_SAVED_MESSAGE:
            return {
                ...state,
                showSavedMessage: action.isSave
            };

        // Customer limit-related actions
        case SET_CUSTOMER_LIMIT:
            return {
                ...state,
                customerLimit: {
                    currency: payload.currency,
                    balance: {
                        initial: payload.balance.initial,
                        initialExpiryDate: payload.balance.initialExpiryDate,
                        totalSpend: payload.balance.totalSpend,
                        available: payload.balance.available
                    },
                    error: null // Clear any previous errors on successful fetch
                }
            };

        case SET_CUSTOMER_LIMIT_ERROR:
            return {
                ...state,
                customerLimit: {
                    ...state.customerLimit,
                    error: payload?.error
                }
            };

        default:
            return state;
    }
};

export default reducer;
